// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/components/label.scss
// module id = 429
// module chunks = 0